const salesDashBoard = () => import('../views/sales/dashboard/dashboard')
const salesDashBoard2 = () => import('../views/sales/dashboard2/dashboard')
const salesDashBoard3 = () => import('../views/sales/dashboard3/dashboard')
const salesDashBoard2Close = () => import('../views/sales/dashboard2/component/closed')

export default [
  {
    path: '/sales/old/dashboard',
    name: 'sales-dashbard',
    component: salesDashBoard
  },
  {
    path: '/sales/old/dashboard2',
    name: 'sales-dashbard2',
    component: salesDashBoard2
  },
  {
    path: '/sales/dashboard',
    name: 'sales-dashbard3',
    component: salesDashBoard3
  },
  {
    path: '/sales/old/dashboard2Close',
    name: 'sales-dashboard2Close',
    component: salesDashBoard2Close
  },
]